<template>
  <v-row no-gutters justify="center" align="center">
      <v-col cols="12">
          <v-row no-gutters justify="center" align="stretch">
              <v-col cols="12" md="8" xl="5" lg="7" class="pa-4">
                  <v-row no-gutters class="item" align="center" justify="center">
                      <v-col cols="12" class="white box center">
                          <v-row no-gutters>
                              <v-col cols="12" class="logo pt-4 text-center">
                                  <img src="@/assets/logo.png">
                              </v-col>
                              <v-col cols="12" class="text-center details pt-4 pb-1">
                                <i class="secondary--text">Portale Cauzioni</i>
                              </v-col>
                              <v-col cols="12">
                                  <h5 class="text-center pb-4" v-if="!error.validation">Inserisci i dati utente per accedere</h5>
                                  <h5 class="text-center pb-4 red--text" v-else>I dati inseriti non risultano corretti</h5>
                              </v-col>
                              <v-col cols="12">
                                  <form class="row justify-center no-gutters">
                                      <v-col cols="8" class="pb-2">
                                          <input type="text" v-model="form.email" class="input" autocomplete="email" placeholder="Email" :class="{ inputErr: error.email }">
                                      </v-col>
                                      <v-col cols="8" class="pb-4">
                                          <input type="password" v-model="form.password" class="input" placeholder="Password" autocomplete="current-password" :class="{ inputErr: error.password }">
                                      </v-col>
                                      <v-col cols="12" class="pb-5 text-center">
                                          <v-btn rounded depressed color="primary" class="pl-10 pr-10" @click="submit">
                                            <span v-if="!loading">Accedi</span>
                                            <v-progress-circular
                                                v-else
                                                indeterminate
                                                color="white"
                                                :size="20"
                                                :width="2"
                                            ></v-progress-circular>
                                          </v-btn>
                                      </v-col>
                                  </form>
                              </v-col>
                          </v-row>
                      </v-col>
                  </v-row>
              </v-col>
          </v-row>
      </v-col>
  </v-row>
</template>

<script>
    import firebase from "firebase";
    import {db} from "@/main";

    export default {
      data() {
        return {
          form: {
            email: "",
            password: "",
          },
          loading: false,
          contact: false,
          error: {
            email: false,
            password: false,
            validation: false,
            message: null,
          }
        };
      },
      methods: {
        submit() {
          this.loading = true
          this.error = {
            email: false,
            password: false,
            validation: false,
            message: null
          }
          if(this.form.password.length <= 0 || !this.validateEmail(this.form.email)) {
            if(this.form.password.length <= 4) {
              this.error.password = true
            }
            if(!this.validateEmail(this.form.email)) {
              this.error.email = true
            }
            this.loading = false
          } else {
            firebase
              .auth()
              .signInWithEmailAndPassword(this.form.email, this.form.password)
              .then(() => {
                // update auth
                db.collection("users").doc(firebase.auth().currentUser.uid).update({
                  "updated_at": firebase.firestore.Timestamp.fromDate(new Date())
                }).then(() => {
                  db.collection("users").doc(firebase.auth().currentUser.uid).get().then((snap) => {
                    this.$store.commit('setAuth',snap)
                    this.$router.replace({ name: "Request" });
                  })
                })
              })
              .catch(() => {
                this.error.validation = true
                this.loading = false
              });
          }
        },
        validateEmail: function (email) {
          let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        }
      },
    };
</script>

<style lang="scss" scoped>
    i{
      font-weight: 500 !important;
    }
    .sub{
        font-weight: 600;
        font-size: 20px;
        color: var(--v-secondary-base);
    }
    .partners{
        img{
            max-width: 100%;
        }
    }
    .center{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .lead{
        font-size: 1.75rem;
        font-weight: 600;
        font-style: italic;
    }
    .details{
        font-size: 1.25rem;
        line-height: 1.65rem;
    }
    .content{
        min-height: 100vh;
        display: flex;
        flex-flow: column;
    }
    .input{
        border: 1px solid var(--v-background-base);
        padding: 6px 16px;
        border-radius: 8px;
        outline: none;
        margin: auto;
        width: 100%;
        font-size: 0.95rem;
    }
    .box{
        border-radius: 8px;
        box-shadow: 0 1px 3px 0 rgba(21,27,38,.15);
        .logo{
            img{
                margin: auto;
                display: block;
                max-height: 50px;
            }
        }

    }
    .auth{
      margin: 0;
      position: absolute;
      top: 50%;
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }
</style>
